/**
 * BrandDashboardContainer
 * --
 */
import React from 'react';
import BrandDashboardPresenter from './BrandDashboardPresenter';

const BrandDashboardContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <BrandDashboardPresenter />
    </>
  );
};

export default BrandDashboardContainer;
